import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import configureStore from '../redux/configureStore';
import ConnectedProviders from './ConnectedProviders';

const store = configureStore();

function App() {
    return (
        <Provider store={store}>
            <Router>
                <Route path="/" render={() => <ConnectedProviders id="app" />} />
            </Router>
        </Provider>
    );
}

export default App;
